<div class="tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-p-12 tw-my-4 tw-border
            tw-border-solid tw-border-grey-400 tw-rounded-lg tw-bg-white tw-overflow-hidden
            tw-whitespace-nowrap"
     data-cy="mb-empty-address-tile">
  <div>
    <h4 class="tw-m-0 tw-text-lg tw-pb-2">{{headline}}</h4>
    <p class="tw-m-0 tw-text-grey-700 tw-whitespace-break-spaces">{{message}}</p>
    <div class="tw-pt-4">
      <mb-link [useSlot]="true" [linkData]="{ url: allProductCategoriesUrl }">
          <span [innerHTML]="linkText"></span>
      </mb-link>
    </div>
  </div>
</div>